// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"279":"component---src-pages-index-jsx","415":"component---src-pages-404-jsx","869":"styles"}[chunkId] + "-" + {"279":"27e548daf98d29877049","415":"caad013ce50fac39d65b","869":"071f6bc1793db3323f8e"}[chunkId] + ".js";
};